import type { DocumentIntelligence, Theme, FontPairing } from "@structurify/shared-types";

interface Props {
  fieldId: string;
  intel: DocumentIntelligence | null;
  theme: Theme;
  fonts: FontPairing;
}

export function FieldChips({ fieldId, intel, theme, fonts }: Props) {
  const chips = intel?.field_chips[fieldId];
  if (!chips?.length) return null;

  const toneColor = (tone: string) => {
    if (tone === "caution") return theme.confidenceLow;
    return theme.inkSoft;
  };
  const toneIcon = (tone: string) => {
    if (tone === "positive") return "✓";
    if (tone === "caution") return "⚠";
    return "·";
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6 }}>
      {chips.map((c, i) => (
        <div
          key={i}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            padding: "2px 7px",
            fontFamily: fonts.sans,
            fontSize: 10.5,
            color: toneColor(c.tone),
            background: c.tone === "caution" ? `${theme.confidenceLow}11` : theme.chipBg,
            border: `1px solid ${c.tone === "caution" ? `${theme.confidenceLow}33` : theme.chipBorder}`,
            letterSpacing: "-0.005em",
          }}
        >
          <span style={{ fontSize: 9, fontFamily: fonts.mono }}>{toneIcon(c.tone)}</span>
          <span>{c.text}</span>
        </div>
      ))}
    </div>
  );
}
